import React from "react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { Badge } from "../ui/badge";
import { CURRENT_COURSE_NAME_KEY } from "@/utils/localStoragekeys";
import { Medal, Clock, Play } from "lucide-react";

export default function CourseCard({ course, onViewDetails }) {
  const navigate = useNavigate();

  return (
    <div className="w-[21rem] h-[32rem] bg-white rounded-3xl shadow-xl relative !border-[var(--primary-font)]/20 overflow-scroll">
      <div>
        <img
          src={course.image}
          alt={course?.title || "Course image"}
          className="w-full h-[15rem] object-cover bg-[var(--primary-font)]/20"
          loading="lazy"
          draggable="false"
        />
        <div className="absolute font-[400] border-2 border-[#0000001A] top-4 left-4 bg-white px-3 py-1 rounded-full text-sm text-gray-700">
          COURSE ID - {course.id.slice(-6)}
        </div>
      </div>

      {/* Content */}
      <div className="relative px-6 w-full h-[15rem] py-4 flex flex-col items-end justify-between">
        <div className="w-full space-y-4 mb-4">
          {/* Title */}
          <h3 className="text-lg font-bold text-black line-clamp-2">
            {course.title}
          </h3>

          {/* Tags */}
          <div className="w-full flex gap-1 overflow-x-auto">
            {course.tags &&
              course.tags.map((tag, idx) => (
                <Badge
                  key={idx}
                  variant="blue"
                  className="px-3 py-1 rounded-full bg-[#C9E9FF] text-[var(--secondary-font)]"
                >
                  <span className="text-xs font-normal">{tag}</span>
                </Badge>
              ))}
          </div>

          {/* Description */}
          <p className="w-full text-gray-600 text-xs leading-relaxed line-clamp-2">
            {course.description}
          </p>
        </div>

        {/* MinPassPercentage, Duration, Action */}
        <div className="flex items-center justify-between w-full">
          <div className="flex gap-6">
            {/* Min Pass Percentage */}
            <div className="flex flex-col">
              <div className="flex items-center gap-2 mb-1">
                <Medal className="w-4 h-4 text-gray-600" />
                <span className="text-lg font-bold text-gray-900">
                  {course.passingScore}%
                </span>
              </div>
              <span className="text-xs text-gray-500">Min. Pass %</span>
            </div>

            {/* Course Duration */}
            <div className="flex flex-col">
              <div className="flex items-center gap-2 mb-1">
                <Clock className="w-4 h-4 text-gray-600" />
                <span className="text-lg font-bold text-gray-900">
                  {course.courseDuration}min
                </span>
              </div>
              <span className="text-xs text-gray-500">Duration</span>
            </div>
          </div>

          {/* Play Button */}
          <Button
            onClick={() => {
              localStorage.setItem(CURRENT_COURSE_NAME_KEY, course.title);
              if (onViewDetails) {
                onViewDetails(course);
              } else {
                navigate(`/dashboard/courses/${course.id}`, {
                  state: {
                    courseName: course.title,
                  },
                });
              }
            }}
            className="w-12 h-12 rounded-full bg-[var(--primary-font)] p-0 flex items-center justify-center"
          >
            <Play className="w-5 h-5 text-white fill-white ml-0.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
